module.exports = __webpack_public_path__ + "static/assurance3-78ebe2f3c86e168e0f6185a4fcfc3099.jpg";